import { actionTypes } from './actionTypes';

export const updateNextMaterial = (payload) => ({
  type: actionTypes.UPDATE_NEXT_MATERIAL,
  payload,
});

export const createOrganizerLink = (payload) => ({
  type: actionTypes.CREATE_ORGANIZER_LINK,
  payload,
});

export const updateCourseProgress = (payload) => ({
  type: actionTypes.UPDATE_COURSE_PROGRESS,
  payload,
});
